import React, { Component } from "react";

import "./style.scss";

import User from "./elements/user/";
import Admin from "./elements/admin/";
import { useAppContext } from "../../../../AppContext"; // Adjust the import path as necessary

import { Navigate, Redirect } from "react-router-dom";

const Dashboard = () => {
  const { user } = useAppContext();

  if (!user?.data) return null;

  switch (user.data.type) {
    case "admin":
      return <Admin />;
    default:
      return <User />;
  }
};

export default Dashboard;
